import React , {Fragment, useState} from "react";
import {AiOutlineSearch} from "react-icons/ai";
import API_KEY from "../../Config/keys";
import {IoMdMic} from "react-icons/io";
import {FaTimes} from "react-icons/fa";
import {connect} from "react-redux";
import "../Body/Body.css";
// import useGoogleSearch from "../../Config/useGoogleSearch"; //CUSTOM HOOK
import {withRouter} from "react-router-dom";


const CONTEXT_KEY =  "1ad1c230bfd086df4";
const SearchInput =(props)=>{
    const [input, setInput] = useState("");
    
    const startSearching=(term)=>{
        const fetchData = async()=>{
            
            fetch(
                  `https://www.googleapis.com/customsearch/v1?key=${API_KEY}&cx=${CONTEXT_KEY}&q=${term.trim().toLowerCase()}`
              ).then(response => response.json())
              .then(result => {
                  props.history.push("/search-results/all");
                  props.updateData(result);
                      
              })
          }
          if(term && term !== ""){
              fetchData();
          }
    }
    const submitSearch=(event)=>{
             event.preventDefault();
             startSearching(input);        
    }
    const voiceRecognition=()=>{
        window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if("SpeechRecognition" in window){
            let recognition = new window.SpeechRecognition();
            recognition.start();
            // console.log(recognition);
            recognition.onstart = function(){
                console.log("starting");
            };
            recognition.onresult = function(e){
                const transcript = e.results[0][0].transcript;
                props.changeTerm(transcript);
                startSearching(transcript);
            }
            recognition.onerror = function(e){
                alert(e.error);
                console.log("error",e.error);
            }
            recognition.onend = function(){
                //   recognition.end();
            }
        }else{
            alert("Your device is not compatible with the service")
        }
    }
    return(
        <Fragment>
            <form onSubmit={(event)=> submitSearch(event)} className="search_form">
                    <AiOutlineSearch className="search-icon" />
                    <input value={props.termInserted} onChange={(e) => { setInput(e.target.value); props.changeTerm(e.target.value)}} className="search_input" type="text" label-area="google" />
                    <div className="search_right_ctrls">
                        {
                            props.termInserted  ?
                            <FaTimes onClick={()=> props.clearInput()} className="search-clear" />
                            : null
                        }
                        <IoMdMic onClick={()=> voiceRecognition()} className="search-mic" /> 
                    </div>
                   
           </form>
        </Fragment>
    )   
}
const mapStateToProps = state =>{
    return{
        termInserted: state.termInserted,
        receivedData : state.receivedData
    }
}
const dispatchStateToProps= dispatch =>{
    return{
        changeTerm : (payload) => dispatch({type: "CHANGE_TERM", payload: payload}),
        updateData : (payload) => dispatch({type: "UPDATE_DATA", payload:payload}),
        clearInput : () => dispatch({type:"CLEAR_INPUT"})
    }
}
export default connect(mapStateToProps, dispatchStateToProps) (withRouter(SearchInput));